import React from 'react';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero-section">
      <div className="container">
        <div className="row align-items-center min-vh-100">
          <div className="col-lg-6">
            <h1 className="display-4 fw-bold text-white mb-4">
              Polzenrom Ltd
            </h1>
            <h2 className="h3 text-white mb-3">IT and Tech Services</h2>
            <p className="lead text-white mb-4">
              Reliable IT and Tech Solutions
            </p>
            <p className="text-white mb-4">
              We specialize on developing, deploying, and managing digital products and platforms.
            </p>
            <div className="d-flex gap-3">
              <button 
                className="btn btn-warning btn-lg"
                onClick={() => scrollToSection('services')}
              >
                Our Services
              </button>
              <button 
                className="btn btn-outline-light btn-lg"
                onClick={() => scrollToSection('contact')}
              >
                Get In Touch
              </button>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="hero-image text-center">
              <i className="fas fa-laptop-code fa-10x text-warning opacity-75"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
